import React, { useState } from "react";
import PropTypes from "prop-types";
import * as Styled from "./ToolAccordion.styled";
import CustomTooltip from "../CustomTooltip";
import TextView from "../../../TextView";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ToolAccordion = ({
  title,
  children,
  AccordionSummaryStyle = {},
  AccordionContainerStyle = {},
  RightIconComponent,
  isTootTipShow = false,
  toolTipDescription = null,
  leftMargin = "75%",
  accordionIcon,
  hideDivider,
  onChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = () => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    if (onChange) {
      onChange(newExpanded);
    }
  };

  return (
    <Styled.AccordionContainer style={AccordionContainerStyle}>
      <Styled.AccordionSummary
        onClick={handleToggleExpand}
        style={{
          ...AccordionSummaryStyle,
          borderBottom: !hideDivider ? "1px solid #f7f2fa" : "none",
        }}
      >
        <Styled.SummaryContent>
          {accordionIcon && (
            <Styled.AccordionImage alt="icon" src={accordionIcon} />
          )}
          <TextView variant="subtitle">{title}</TextView>
          {isTootTipShow && (
            <Tooltip title={toolTipDescription} placement="top" arrow>
              <InfoOutlinedIcon
                sx={{
                  color: "#123051",
                  cursor: "pointer",
                  ml: "5px",
                }}
              />
            </Tooltip>
          )}
        </Styled.SummaryContent>
        <Styled.RightIcon style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
          {RightIconComponent && <RightIconComponent />}
        </Styled.RightIcon>
      </Styled.AccordionSummary>
      {expanded && (
        <Styled.AccordionDetails>{children}</Styled.AccordionDetails>
      )}
    </Styled.AccordionContainer>
  );
};

ToolAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  AccordionSummaryStyle: PropTypes.object,
  RightIconComponent: PropTypes.elementType,
  isTootTipShow: PropTypes.bool,
  toolTipDescription: PropTypes.string,
  leftMargin: PropTypes.string,
  accordionIcon: PropTypes.string,
  hideDivider: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ToolAccordion;
